import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Col} from 'react-bootstrap';
import ArrowButton from '../common/button-arrow';
import {deletePage} from '../../actions/pages';


const linksMap = {
  "my-profile": "/my-profile",
  "login": "/login",
  "request-pin": "/reset-password",
  "enter-pin": "/enter-pin",
  "enter-security-questions": "/seq-questions",
  "set-new-password": "/new-password",
  "outlet-validation": "/registration/outlet",
  "about-you": "/registration/about-you",
  "your-store": "/registration/your-store",
  "store-summary": "/store_summary",
  "store-details": "/store-details/:id",
  "my-staff": "/my-staff",
  "new-order": "/order/new",
  "order-confirmation": "/order/:id/confirm",
  "my-orders": "/my-orders",
  "view-order": "/my-orders/:id",
  "how-to-earn": "/how-to-earn",
  "store-performance": "/admin/store-performances",
  "points-statement": "/admin/points-statement",
  "staff-rewards": "/staff-rewards",
  "personal-rewards-opted-out": "/personal-rewards",
  "personal-rewards-opted-in": "/personal-rewards",
  "contact-us-pre-login": "/contact",
  "contact-us-post-login": "/contact-us",
  "my-messages": "/my-messages",
  "about-ignite": "/about-ignite",
  "latest-news": "/latest-news",
  "about-vaping": "/about-vaping",
  "myblu": "/myblu",
  "educating-your-customer": "/educating-your-customer"
};

class OnePage extends React.Component {

  onDeleteClicked = () => {
    const {dispatch, page} = this.props;
    dispatch(deletePage(page.id));
  };

  fulLink = () => {
    const {page} = this.props;
    const link = page.slug;

    if (page.group === 'Brands') {
      return `${window.location.origin}/${link}`;
    }

    const currentLink = page.group === 'Content' ? link.replace(new RegExp('_', 'g'), "-") : linksMap[page.slug];
    if (page.group === 'Content') {
      return window.location.origin + '/content-pages/' + (currentLink || "");
    }
    return window.location.origin + (currentLink || "");
  };

  render() {
    const {page} = this.props;
    const link = page.slug;
    const fullLink = this.fulLink();
    const details = `/admin/pages-add-edit/${page.id}`;


    return (
      <div>
        <Col md={12}>
          <div className="one-page">
            <Col md={3}>{page.name}</Col>
            <Col md={3}><Link to={`/content-page/edit/${link}`} target="_blank">{fullLink}</Link></Col>
            {page.group === 'Content' && (
              <Col md={6}>
                <ArrowButton submit={false}
                             arrow={false}
                             onClick={this.onDeleteClicked}
                             className="pull-right"
                             permissions={{
                               action: "destroy",
                               subjectClass: "Page",
                             }}>Delete</ArrowButton>
                <Link to={details}>
                  <ArrowButton submit={false}
                               arrow={false}
                               className="pull-right"
                               color="grey"
                               permissions={{
                                 action: "update",
                                 subjectClass: "Page",
                               }}>Edit</ArrowButton>
                </Link>
              </Col>
            )}
          </div>
        </Col>
      </div>
    );
  }
}

export default connect()(OnePage);



// WEBPACK FOOTER //
// ./src/components/pages/one-page.jsx